import type { TTransportSubtype } from 'api/swagger';

export const isTruckWithTrailer = (truckSubType?: TTransportSubtype): boolean => {
  return truckSubType !== 'truck_head' && truckSubType !== 'roadtrain';
};

export const getTrailerSubTypesByTrain = (truckType?: TTransportSubtype): TTransportSubtype[] => {
  switch (truckType) {
    case 'truck_head':
      return ['mega', 'platform'];
    case 'roadtrain':
      return ['roadtrain_trailer'];
    default:
      return [];
  }
};
